/**
 * An enum that includes all printable string values one can expect from `event.key`.
 */
export enum Symbol {
  Zero = '0',
  ClosedParen = Zero,
  One = '1',
  ExclamationMark = One,
  Two = '2',
  AtSign = Two,
  Three = '3',
  PoundSign = Three,
  Hash = PoundSign,
  Four = '4',
  DollarSign = Four,
  Five = '5',
  PercentSign = Five,
  Six = '6',
  Caret = Six,
  Hat = Caret,
  Seven = '7',
  Ampersand = Seven,
  Eight = '8',
  Star = Eight,
  Asterik = Star,
  Nine = '9',
  OpenParen = Nine,
  A = 'a',
  B = 'b',
  C = 'c',
  D = 'd',
  E = 'e',
  F = 'f',
  G = 'g',
  H = 'h',
  I = 'i',
  J = 'j',
  K = 'k',
  L = 'l',
  M = 'm',
  N = 'n',
  O = 'o',
  P = 'p',
  Q = 'q',
  R = 'r',
  S = 's',
  T = 't',
  U = 'u',
  V = 'v',
  W = 'w',
  X = 'x',
  Y = 'y',
  Z = 'z',
  Numpad0 = 'Numpad0',
  Numpad1 = 'Numpad1',
  Numpad2 = 'Numpad2',
  Numpad3 = 'Numpad3',
  Numpad4 = 'Numpad4',
  Numpad5 = 'Numpad5',
  Numpad6 = 'Numpad6',
  Numpad7 = 'Numpad7',
  Numpad8 = 'Numpad8',
  Numpad9 = 'Numpad9',
  Multiply = 'NumpadMultiply',
  Add = 'NumpadAdd',
  Subtract = 'NumpadSubtract',
  DecimalPoint = 'NumpadDecimal',
  Divide = 'NumpadDivide',
  SemiColon = ';',
  Equals = '=',
  Comma = ',',
  Dash = '-',
  Period = '.',
  UnderScore = Dash,
  PlusSign = Equals,
  ForwardSlash = '/',
  QuestionMark = ForwardSlash,
  GraveAccent = '`',
  BackQuote = GraveAccent,
  Tilde = GraveAccent,
  BracketLeft = '[',
  CurlyBracketLeft = BracketLeft,
  BracketRight = ']',
  CurlyBracketRight = BracketRight,
  Quote = "'"
}
